import { render, staticRenderFns } from "./ModalEditar.vue?vue&type=template&id=494e7984&scoped=true&"
import script from "./ModalEditar.vue?vue&type=script&lang=js&"
export * from "./ModalEditar.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditar.vue?vue&type=style&index=0&id=494e7984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e7984",
  null
  
)

export default component.exports